import React from 'react';
import CommonHeader from './commonheader/CommonHeader'
import Footer from './Footer';
import DesignBrief from './ourprocess/DesignBrief';
import Ideation from './ourprocess/Ideation';
import Designing from './ourprocess/Designing';
import Sampling from './ourprocess/Sampling';
import CuttingAndStitching from './ourprocess/Cutting&Stitching';
import QualityControl from './ourprocess/QualityControl';
import Packaging from './ourprocess/Packaging';


const OurProcess = () => {
  return (
    <div>
        <CommonHeader/>
        <DesignBrief/>
        <Ideation/>
        <Designing/>
        <Sampling/>
        <CuttingAndStitching/>
        <QualityControl/>
        <Packaging/>
        <Footer/>
    </div>
  )
}

export default OurProcess